export default {
  "content": "<path d=\"M256 232v-80\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M256 88V72m-124 60l-12-12\" class=\"ionicon-fill-none\"/><circle cx=\"256\" cy=\"272\" r=\"32\" class=\"ionicon-fill-none ionicon-stroke-width\"/><path d=\"M256 96a176 176 0 10176 176A176 176 0 00256 96z\" class=\"ionicon-fill-none ionicon-stroke-width\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};